import { render, staticRenderFns } from "./Reproductor.vue?vue&type=template&id=0d24fe97&"
import script from "./Reproductor.vue?vue&type=script&lang=js&"
export * from "./Reproductor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports